(function (window, $) {
  class RadioGroup {
    constructor(options) {
      this.options = $.extend(
        {
          data: [], // { value: NumberString; name: string; disabled?: boolean}[]
          value: null, // Selected value
          disabled: false,
          container: null,
          labelSlot: null, // Function (item) => string | DOM | jQuery
          cancelSelect: false,
        },
        options,
      );

      this.emitter = window.useEmitter();
      this.radios = [];
      this.$html = null;
      this.init();
    }

    init() {
      this.$html = $("<div>").addClass("radio-group");
      if (this.options.container) {
        $(this.options.container).append(this.$html);
      }
      this.render();
    }

    render() {
      this.$html.empty();
      this.radios = [];

      const { data, value, disabled, labelSlot, cancelSelect } = this.options;

      if (!Array.isArray(data)) return;

      data.forEach((item) => {
        const isChecked = value === item.value;
        const isDisabled = disabled || item.disabled;

        let itemLabelSlot = item.labelSlot;
        if (typeof labelSlot === "function") {
          itemLabelSlot = labelSlot(item);
        }

        const radio = new window.Radio({
          value: item.value,
          label: item.name,
          labelSlot: itemLabelSlot,
          checked: isChecked,
          disabled: isDisabled,
          container: this.$html,
          cancelSelect,
        });

        // Listen to change event
        radio.emitter.on("change", (checked, val) => {
          this.handleRadioChange(checked, val);
        });

        this.radios.push(radio);
      });
    }

    handleRadioChange(checked, val) {
      // Uncheck all other radios
      this.radios.forEach((radio) => {
        if (radio.value !== val) {
          radio.setValue(false);
        }
      });
      this.options.value = checked ? val : null;
      this.emitter.emit("change", this.options.value);
    }

    getValue() {
      return this.options.value;
    }

    setValue(value) {
      this.options.value = value;

      this.radios.forEach((radio) => {
        const shouldCheck = radio.value === value;
        radio.setValue(shouldCheck);
      });
    }

    setDisabled(disabled) {
      this.options.disabled = disabled;
      this.radios.forEach((radio) => {
        if (disabled) {
          radio.setDisabled(true);
        } else {
          const item = this.options.data.find((d) => d.value === radio.options.value);
          if (item && item.disabled) {
            radio.setDisabled(true);
          } else {
            radio.setDisabled(false);
          }
        }
      });
    }

    updateData(data) {
      if (data) {
        this.options.data = data;
      }
      this.render();
    }
  }

  window.RadioGroup = RadioGroup;
})(window, jQuery);
